/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { FETCH_REFINANCED_CONTRACTS_REQUEST, success, failure } from './action';

const fetchContracts = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(FETCH_REFINANCED_CONTRACTS_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ contractId, params }) =>
      AjaxRequest.open(
        'get',
        `/admin/contractcustom/contracts/${contractId}/refinancedcontracts?${params.toString()}`,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchContracts);
